var map = {
	"./electrodeio/default-messages": 140
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 139;



//////////////////
// WEBPACK FOOTER
// ./src/lang/tenants ^\.\/.*\/default\-messages$
// module id = 139
// module chunks = 0